import CustomInput from "../../../../../../Component/DigitalMarketing/CustomInput";
import { useGetAdviceQuery } from "../../../../../../Service/PatientList";

const Advice = (props: any) => {
  const { formData, setFormData, handleChange, submit } = props;

  const { data: adviceData } = useGetAdviceQuery();

  const adviceOptions = adviceData?.data
    ? [{ label: adviceData.data.advice, value: adviceData.data.id.toString() }]
    : [];

  const selectedAdvice = adviceOptions.find(
    (opt: any) => opt.value === formData?.advice?.toString()
  );

  return (
    <div>
      <div className="row mt-3">
        <span className="prescription-headline col-12 rounded mb-3">Advice</span>

        <div className="col-6">
          <CustomInput
            type="select"
            option={adviceOptions}
            labelKey="label"
            valueKey="value"
            // validation="required"
            submit={submit}
            name="advice"
            value={formData?.advice?.toString() || ""}
            onChange={handleChange}
            setFormData={setFormData}
          />
        </div>

        <div className="col-12 mt-3">
          <CustomInput
            type="textarea"
            name="adviceText"
            value={selectedAdvice?.label || ""}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Advice;
